import { render, staticRenderFns } from "./EditItemPage.vue?vue&type=template&id=479a759b&scoped=true&"
import script from "./EditItemPage.vue?vue&type=script&lang=js&"
export * from "./EditItemPage.vue?vue&type=script&lang=js&"
import style0 from "./EditItemPage.vue?vue&type=style&index=0&id=479a759b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a759b",
  null
  
)

export default component.exports